export default "__VITE_ASSET__DAsi21S0__"